import { Injectable } from '@angular/core';

import { EntityStore, StoreConfig } from '@datorama/akita';

import { LocationsState } from './locations.state';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'locations', idKey: '_id' })
export class LocationsStore extends EntityStore<LocationsState> {
  constructor() {
    super();
  }
}
